import React from "react";
import Tab from "@mui/material/Tab";
import { TabPanel as MUITabPanel, TabContext, TabList } from "@mui/lab";

function TabPanel({ tabs, selectedTab, onTabChange }) {
  const handleChange = (event, newValue) => {
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  return (
    <TabContext value={selectedTab}>
      <div style={{ display: "flex", justifyContent: "center", borderBottom: 1 }}>
        <TabList
          value={selectedTab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="secondary"
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{
            style: {
              backgroundColor: "red",
              textColor: "black",
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              value={"" + index}
              label={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {tab.icon}
                  <span style={{ marginLeft: "8px" }}>{tab.label}</span>
                </div>
              }
              style={
                !tab.style
                  ? {
                      color: "black",
                      fontWeight: "bolder",
                      textTransform: "none",
                    }
                  : tab.style
              }
            />
          ))}
        </TabList>
      </div>
      {tabs.map((tab, index) => (
        <MUITabPanel
          key={index}
          value={"" + index}
          style={
            !tab.tabPanelStyle
              ? {
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  paddingBottom: "10px",
                }
              : tab.tabPanelStyle
          }
        >
          {tab.children}
        </MUITabPanel>
      ))}
    </TabContext>
  );
}

export default TabPanel;
